import * as yup from "yup";

// const phoneRegExp = /(^[+ 0-9\-\.()]{8,18}$)|.*null|null/gm;
// const phoneRegExp = /test/;

export const contactFormSchema = yup.object({
  firstname: yup.string().required("First name is required"),
  lastname: yup.string().required("Last name is required"),
  phone: yup.string().nullable(),
  // .matches(phoneRegExp, { message: "Phone number is not valid" })
  email: yup
    .string()
    .email("Invalid email address")
    .required("Email is required"),
  message: yup.string().required("Message is required"),
});
